import React, { memo } from 'react';

export const RestaurantTitle = memo(({ name }) => (
    <div className="title">
        <h3>{name}</h3>
    </div>
))